import React from 'react';
import { Modal } from 'react-bootstrap';
import countries from '../utils/Countries';

const LeadModal = ({ show, onHide, onSave, newLeadData, setNewLeadData, loading }) => {
  const handleChange = (e) => {
    setNewLeadData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Создать новый лид</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          {['datetime', 'name', 'telefon', 'email', 'source', 'kommentarsKonto', 'kommentarOperator'].map((colId) => (
            <div className="mb-3" key={colId}>
              <label htmlFor={colId}>{colId === 'datetime' ? 'Дата и время' : colId}</label>
              <input
                id={colId}
                type="text"
                className="form-control"
                name={colId}
                value={newLeadData[colId] || ''}
                onChange={handleChange}
              />
            </div>
          ))}

          <div className="mb-3">
            <label htmlFor="country">Страна</label>
            <select
              id="country"
              name="country"
              className="form-control"
              value={newLeadData.country}
              onChange={handleChange}
            >
              {countries.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label htmlFor="status">Статус</label>
            <select
              id="status"
              name="status"
              className="form-control"
              value={newLeadData.status}
              onChange={handleChange}
            >
              <option value="New">New</option>
              <option value="NA">NA</option>
              <option value="NI">NI</option>
              <option value="Wrong">Wrong</option>
              <option value="Unaviable">Unaviable</option>
              <option value="Depositor">Depositor</option>
              <option value="VM">VM</option>
              <option value="HU">HU</option>
            </select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Отмена
        </button>
        <button className="btn btn-primary" onClick={onSave} disabled={loading}>
          Создать
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LeadModal;
